import { Component } from "react"
import { RouteComponentProps } from "react-router-dom"
import { Dashboard } from "./dashboard"

export class DashboardInternal extends Component<RouteComponentProps<{}>> {
    render() {
        return <Dashboard {...this.props} external={false} />
    }
}